import { render, staticRenderFns } from "./OrganizationDeleteMember.vue?vue&type=template&id=01e46145&scoped=true"
import script from "./OrganizationDeleteMember.vue?vue&type=script&lang=js"
export * from "./OrganizationDeleteMember.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDeleteMember.vue?vue&type=style&index=0&id=01e46145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e46145",
  null
  
)

export default component.exports